module.exports = __webpack_public_path__ + "static/media/team-chat.68b117ce.png";